<template>
  <f7-page :page-content="false">
    <f7-navbar :title="config.title" :back-link="$t('atras')"></f7-navbar>
    <f7-page-content class="full-height">
      <r-dynamic-list
        ref="rlist"
        :dbAdapter="config.dbAdapter"
        :tableCode="config.tableCode"
        :tableMode="true"
        :virtualListParams="{height:32, rowsBefore:60, rowsAfter:60}"
        class="card full-height data-table"
        classContent="card-content full-height"
        :massiveActions="true"
        :controlsWidth="100"
      >
        <template v-slot:tableLinks>
          <a class="link" :href="`${config.routeBase}new/`">Nuevo {{ config.singular }}</a>
        </template>
        <template v-slot:optionsColumn="{item}">
          <f7-link v-tooltip="$t('common.ver')" icon-f7="eye" color="green" :href="`${config.routeBase}view/${item.id}/`"></f7-link>
          <f7-link icon-f7="square_pencil" color="blue" :href="`${config.routeBase}edit/${item.id}/`"></f7-link>
          <f7-link icon-f7="trash" color="red" @click="deleteItem(item.id)"></f7-link>
        </template>
      </r-dynamic-list>
    </f7-page-content>
  </f7-page>
</template>

<script>
import rDynamicList from '../../components/rDynamicList.vue';
import { getAiContextConfig } from './config.js';

export default {
  components: {
    rDynamicList
  },
  props: {
    contextType: {
      type: String,
      required: true
    }
  },
  computed: {
    config() {
      return getAiContextConfig(this.contextType);
    }
  },
  methods: {
    deleteItem(id) {
      const self = this;
      self.$f7.dialog.confirm(
        self.$t('rlist.pregunta_eliminar_registro'),
        'Eliminar',
        function () {
          self.config.dbAdapter.delete({ itemId: id }).then(function () {
            self.$f7.toast
              .create({
                icon: '<i class="f7-icons">checkmark</i>',
                text: self.$t('rlist.registro_eliminado'),
                position: 'center',
                destroyOnClose: true,
                closeTimeout: 2000
              })
              .open();
            if (self.$refs.rlist) {
              self.$refs.rlist.refresh();
            }
          }).catch(function (error) {
            self.$f7.dialog.alert(error.message);
          });
        }
      );
    }
  }
};
</script>
